<nz-sider class="menu-sidebar" [nzZeroTrigger]="zeroTrigger"  nzCollapsible [nzWidth]="expandWidth" nzTheme="light" [(nzCollapsed)]="isCollapsed"
  [nzTrigger]="null" [nzCollapsedWidth]="0">
  <div class="container">
    <ul nz-menu nzTheme="light" nzMode="inline" [nzInlineIndent]="0">
      @for (menu of items; track menu) {
        @if (menu.children && menu.children.length > 0) {
          @if (menu.hasPermission) {
            <li [nzOpen]="isActiveSubmenu(menu)" nz-submenu
              nzTitle="{{ menu.title | translate }}" nzIcon="{{ menu.icon }}"
              [ngClass]="isCollapsed ? '' : 'not-collapsed-sub-item'" class="item">
              <ul>
                @for (subMenu of menu.children; track subMenu) {
                  <li nz-menu-item (click)="onNavigation(subMenu)"
                    [nzSelected]="isActiveMenu(subMenu)">
                    <span>{{ subMenu.title | translate }}</span>
                  </li>
                }
              </ul>
            </li>
          }
        } @else {
          @if (menu.hasPermission) {
            <li nz-menu-item (click)="onNavigation(menu)" [nzSelected]="isActiveMenu(menu)"
              [ngClass]="isCollapsed ? '' : 'not-collapsed-item'" class="item">
              <i nz-icon [nzType]="menu.icon"></i>
              <span>{{ menu.title | translate }}</span>
            </li>
          }
        }
      }
    </ul>
  </div>

</nz-sider>

<ng-template #zeroTrigger>
  <i nz-icon type="menu-fold" theme="outline"></i>
</ng-template>